"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserModel = void 0;
const licenseConstants_json_1 = __importDefault(require("../constants/licenseConstants.json"));
const LicenseModel_1 = require("../Model/LicenseModel");
const PackOfferModel_1 = require("../Model/PackOfferModel");
class UserModel {
    constructor(props) {
        Object.assign(this, props);
    }
    static fromJSON(props) {
        return new UserModel({
            affiliatedShopId: props.affiliatedShopId,
            email: props.email,
            firstName: props.firstName,
            id: props.id,
            lastName: props.lastName,
            licenses: LicenseModel_1.LicenseModel.serializeLicenses(props.licenses),
            managedUserIds: props.managedUserIds,
            organisationId: props.organisationId,
            packOffer: new PackOfferModel_1.PackOfferModel(props.packOfferName),
            punchClockAuthorizations: props.punchClockAuthorizations,
            superAdminPermissions: props.superAdminPermissions,
            teamIds: props.teamIds,
        });
    }
    get visibleShopIds() {
        return Object.keys(this.licenses.userLicenseForShop);
    }
    get clusterNodeIds() {
        return Object.keys(this.licenses.userLicenseForCluster);
    }
    get managedShopIds() {
        return this.visibleShopIds.filter((shopId) => this.licenses.userLicenseForShop[shopId].position < licenseConstants_json_1.default.licenseHierarchy.advanced_employee ||
            this.licenses.userLicenseForShop[shopId].originalType === 'access_key_license');
    }
}
exports.UserModel = UserModel;
//# sourceMappingURL=UserModel.js.map